import { FormControl, InputGroup, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import useDebounce from "../../utils/hooks";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import {
  fetchActionsUtil,
  paginationOptions,
  scrollToTop,
} from "../../utils/helpers";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import currency from "currency.js";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ModalLoader from "../utils/ModalLoader";
import { isEmpty } from "lodash";
import NoTableItem from "../utils/NoTableItem";
import { CheckCircleIcon } from "../Icons";

export default function BankModal({ show, onHide, type, onSelectBank }) {
  const { backendUrl, token } = useAuth();

  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
    q: "",
    withBalance: true,
  });

  const [filterParams, setFilterParams] = useState({
    ...queryParams,
  });
  const [isLoading, setIsLoading] = useState();
  const debouncedFilterParams = useDebounce(filterParams, 500);

  useEffect(() => {
    setQueryParams((prev) => ({ ...prev, ...debouncedFilterParams }));
  }, [debouncedFilterParams]);

  const getBanks = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/banks?${queryString.stringify(debouncedqueryParams)}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      },
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };

  const { data = { banks: [] }, refetch, isSuccess, isFetching } = useQuery(
    ["GET_BUISINESS_BANKS", queryParams],
    () => getBanks(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
      page: 1,
    });
  };

  const showOnAccountStatement = async ({
    showOnAccountStatement,
    AccountNo,
  }) => {
    setIsLoading(true);
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-account-statement`,
      "POST",
      "",
      {
        showOnAccountStatement,
        AccountNo,
      },
    );
    refetch();
    onSelectBank();
    toast.success(res.message);
    setIsLoading(false);
  };

  const showOnSubscriptionRenewal = async ({
    showOnSubscriptionRenewal,
    AccountNo,
  }) => {
    setIsLoading(true);
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-subscription-renewal`,
      "POST",
      "",
      {
        showOnSubscriptionRenewal,
        AccountNo,
      },
    );
    refetch();
    onSelectBank();
    toast.success(res.message);
    setIsLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered enforceFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>Select Bank</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="search-area mb-3 gap-3">
          <Form.Group>
            <InputGroup>
              <Form.Control
                className="form-control search-input"
                name="q"
                value={filterParams.q}
                onChange={handleSearchQueryChange}
                placeholder="Search bank..."
                autoFocus
                autoComplete="off"
              />

              <InputGroup.Text>
                <MagnifyIcon />
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>
        </div>

        <div
          className="table-responsive"
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          <Table borderless hover striped className="product-table">
            <thead className="sticky text-nowrap">
              <tr>
                <th>Select</th>
                <th>Enabled On</th>
                <th>Bank Name</th>
                <th>Account Name</th>
                <th>Account No</th>

                <th>Currency</th>
              </tr>
            </thead>
            <tbody>
              {data.banks.map((el, index) => (
                <tr key={index} className="p-cursor">
                  <td>
                    {" "}
                    <Form.Switch
                      checked={el[type] === "yes"}
                      onChange={(e) => {
                        if (type === "showOnSubscriptionRenewal") {
                          showOnSubscriptionRenewal({
                            showOnSubscriptionRenewal:
                              el?.showOnSubscriptionRenewal === "yes"
                                ? ""
                                : "yes",
                            AccountNo: el.AccountNo,
                          });
                        } else {
                          showOnAccountStatement({
                            showOnAccountStatement:
                              el.showOnAccountStatement === "yes" ? "" : "yes",
                            AccountNo: el.AccountNo,
                          });
                        }
                      }}
                    />
                  </td>
                  <td>
                    {el?.showOnSubscriptionRenewal === "yes" && (
                      <div className="d-flex align-items-center mb-2 gap-1">
                        <CheckCircleIcon width={15} height={15} /> Subscription
                        Renewal
                      </div>
                    )}
                    {el?.showOnAccountStatement === "yes" && (
                      <div className="d-flex align-items-center mb-2 gap-1">
                        <CheckCircleIcon width={15} height={15} /> Statement of
                        Account
                      </div>
                    )}
                    {el?.showOnInvoice === "yes" && (
                      <div className="d-flex align-items-center mb-2 gap-1">
                        <CheckCircleIcon width={15} height={15} /> Proforma
                        Invoice
                      </div>
                    )}
                    {el?.showOnSalesInvoice === "yes" && (
                      <div className="d-flex align-items-center mb-2 gap-1">
                        <CheckCircleIcon width={15} height={15} /> Sales Invoice
                      </div>
                    )}
                    {el?.showOnOnlineStore === "yes" && (
                      <div className="d-flex align-items-center mb-2 gap-1">
                        <CheckCircleIcon width={15} height={15} /> Online Store
                      </div>
                    )}
                  </td>
                  <td>{el.BankName}</td>
                  <td>{el.AccountName || "..."}</td>
                  <td>{el.AccountNo}</td>
                  <td>{el.currency}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!isFetching && isSuccess && isEmpty(data.banks) ? (
            <NoTableItem queryParams={queryParams} />
          ) : null}
        </div>

        <div className="d-flex justify-content-between px-3 align-items-center pagination">
          <div className="pagination_left">
            <p className="m-0 p-0">Show</p>
            <select
              value={queryParams.limit}
              name="limit"
              className="form-select"
              onChange={handleSearchQueryChange}
            >
              <option value="10">10 rows</option>
              <option value="20">20 rows</option>
              <option value="30">30 rows</option>
              <option value="40">40 rows</option>
              <option value="50">50 rows</option>
              <option value="100">100 rows</option>
            </select>
          </div>

          <ReactPaginate
            {...paginationOptions}
            pageCount={Math.ceil(data.count / queryParams.limit)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={0}
            onPageChange={({ selected }) => {
              setQueryParams({
                ...queryParams,
                page: selected + 1,
              });
              scrollToTop();
            }}
            forcePage={queryParams.page - 1}
          />
        </div>
      </Modal.Body>
      {/* <ModalLoader show={isLoading} /> */}
    </Modal>
  );
}
